<sl-tab-group>
  <sl-tab [panel]="TAB_NAMES.HOW_TO_USE" slot="nav"> How to use MyToolbox</sl-tab>
  <sl-tab active [panel]="TAB_NAMES.FAQ" slot="nav"> FAQ </sl-tab>
  <sl-tab [panel]="TAB_NAMES.CONTACT" slot="nav"> Contact </sl-tab>

  <sl-tab-panel [name]="TAB_NAMES.HOW_TO_USE">
    <mt-how-to-use></mt-how-to-use>
  </sl-tab-panel>
  <sl-tab-panel [name]="TAB_NAMES.FAQ">
    <mt-faq />
  </sl-tab-panel>
  <sl-tab-panel [name]="TAB_NAMES.CONTACT">
    <mt-contact />
  </sl-tab-panel>
</sl-tab-group>
